import { useCallback, useEffect, useState } from 'react';
import { useTRPCRequest } from '../../../hooks';
import { TRPCMethodEnum, TRPCResourceEnum } from '../../../api/trpcApi/types';
import { toast } from 'react-toastify';
import { Partner } from '../types';

export function usePartners() {
  const { handleTRPCRequest } = useTRPCRequest();

  const [partners, setPartners] = useState<Partner[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchPartners = useCallback(async () => {
    setIsLoading(true);
    const { res: partners, error } = await handleTRPCRequest({
      method: TRPCMethodEnum.list,
      resourceType: TRPCResourceEnum.partners,
      requestBody: {}
    });

    if (error) {
      toast.error('Error fetching partners');
    }
    setPartners(partners as Partner[]);
    setIsLoading(false);
  }, [handleTRPCRequest]);

  useEffect(() => {
    fetchPartners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter to only active partners for selection dropdowns
  const activePartners = partners.filter(p => p.active);

  return { partners, activePartners, isLoading, refetch: fetchPartners };
}
